import React from 'react';
import { Mail, Linkedin, Twitter } from 'lucide-react';
import { Link } from "react-router-dom";
import logo from "../../assets/logo.png";



const Footer = () => {
  const currentYear = new Date().getFullYear();

  const footerLinks = {
    Product: [
      { label: 'Features', href: '#features' },
      { label: 'Solutions', href: '#solutions' },
      { label: 'How It Works', href: '#how-it-works' },
      { label: 'Security', href: '#' },
    ],
    Company: [
      { label: 'About', href: '#about' },
      { label: 'Careers', href: '#' },
      { label: 'Contact', href: '#contact' },
    ],
    Legal: [
      { label: 'Privacy Policy', to: '/PrivacyPolicy' },
      { label: 'Terms of Service', to: '/terms' },
      { label: 'Cookie Policy', to: '/cookies' },
    ],
  };

  const socialLinks = [
    { icon: Linkedin, href: '#', label: 'LinkedIn' },
    { icon: Twitter, href: '#', label: 'Twitter' },
  ];

  return (
    <footer className="bg-slate-950 border-t border-slate-800">
      {/* Top Section */}
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16">
        <div className="grid lg:grid-cols-6 gap-12">
          
          {/* Brand Column */}
          <div className="lg:col-span-2 space-y-5">
            <a href="/" className="flex items-center gap-3">
              <img
                  src={logo}
                alt="TradeEngine.AI"
                className="h-8 w-auto"
              />
              <span className="text-lg font-semibold text-white">
                TradeEngine.AI
              </span>
            </a>

            <p className="text-slate-400 text-sm leading-relaxed">
              The intelligence layer for physical-economy enterprises. Unifying operations,
              finance, and sustainability into actionable insights.
            </p>

            {/* Contact */}
            <a
              href="mailto:hello@thetradeengine.ai"
              className="flex items-center gap-2 text-slate-400 hover:text-white transition-colors text-sm"
            >
              <Mail className="w-4 h-4" />
              hello@thetradeengine.ai
            </a>

            {/* Social Links */}
            <div className="flex items-center gap-2 pt-2">
              {socialLinks.map((social, index) => {
                const Icon = social.icon;
                return (
                  <a
                    key={index}
                    href={social.href}
                    aria-label={social.label}
                    className="w-9 h-9 rounded-lg bg-slate-800 hover:bg-slate-700 flex items-center justify-center transition-colors"
                  >
                    <Icon className="w-4 h-4 text-slate-400" />
                  </a>
                );
              })}
            </div>
          </div>

          {/* Links Columns */}
          {Object.entries(footerLinks).map(([category, links]) => (
            <div key={category}>
              <h4 className="text-white font-medium mb-4 text-sm">
                {category}
              </h4>
              <ul className="space-y-3">
                {links.map((link) => (
                  <li key={link.label}>
                    {link.to ? (
                      <a
                        href={link.to}
                        className="text-slate-400 hover:text-white transition-colors text-sm"
                      >
                        {link.label}
                      </a>
                    ) : (
                      <a
                        href={link.href}
                        className="text-slate-400 hover:text-white transition-colors text-sm"
                      >
                        {link.label}
                      </a>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>

      {/* Bottom Section */}
      <div className="border-t border-slate-800">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 py-5">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-slate-500 text-sm">
              © {currentYear} THE TRADEENGINE.AI PTE. LTD. (202512200G). All rights reserved.
            </p>

            {/* Trust Badges */}
            <div className="flex items-center gap-6">
              <div className="flex items-center gap-2 text-slate-500 text-xs">
                <div className="w-1.5 h-1.5 rounded-full bg-emerald-500" />
                SOC 2 Compliant
              </div>
              <div className="flex items-center gap-2 text-slate-500 text-xs">
                <div className="w-1.5 h-1.5 rounded-full bg-emerald-500" />
                GDPR Ready
              </div>
              <div className="flex items-center gap-2 text-slate-500 text-xs">
                <div className="w-1.5 h-1.5 rounded-full bg-emerald-500" />
                Enterprise Grade
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
